import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "antd/dist/reset.css";

import API from "./services/api";
import axios from "axios";
import ProtectedRoute from "./component/ProtectedRoute/ProtectedRoute";
import React, { useEffect, useState } from "react";
import Loader from "./pages/Loader/Loader";
import ScrollToTop from "./pages/ScrollToTop/ScrollToTop";
import ScrollTopButton from "./pages/ScrollToTop/ScrollTopButton";
import Navbar from "./component/Navbar/Navbar";
import AddYours from "./pages/CRUD/Add/AddYours";
import Explore from "./pages/Explore/Explore";
import Home from "./pages/Home/Home";
import Login from "./pages/Auth/Login/Login";
import Register from "./pages/Auth/Register/Register";
import PersonalDetails from "./pages/Profile/PersonalDetails";
import CommercialSpaces from "./pages/List/CommercialSpaces";
import Stalls from "./pages/List/Stalls";
import Franchises from "./pages/List/Franchises";
import Businesses from "./pages/List/Businesses";
import AddCommercialSpace from "./pages/CRUD/Add/AddCommercialSpace";
import AddStall from "./pages/CRUD/Add/AddStall";
import AddFranchise from "./pages/CRUD/Add/AddFranchise";
import AddBusiness from "./pages/CRUD/Add/AddBusiness";
import AdminCommercialApprovals from "./pages/Admin/AdminCommercialApprovals";
import CommercialSpaceDetails from "./pages/CRUD/Details/CommercialSpaceDetails";
import AdminStallApprovals from "./pages/Admin/AdminStallApprovals";
import StallDetails from "./pages/CRUD/Details/StallDetails";
import FranchiseDetails from "./pages/CRUD/Details/FranchiseDetails";
import AdminFranchiseApprovals from "./pages/Admin/AdminFranchiseApprovals";
import BusinessDetails from "./pages/CRUD/Details/BusinessDetails";
import AdminBusinessApprovals from "./pages/Admin/AdminBusinessApprovals";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminRoute from "./component/ProtectedRoute/AdminRoute";
import MyCommercialSpaces from "./pages/CRUD/Edit/commercial/MyCommercialSpaces";
import EditCommercialSpace from "./pages/CRUD/Edit/commercial/EditCommercialSpace";
import MyStalls from "./pages/CRUD/Edit/stall/MyStalls";
import EditStall from "./pages/CRUD/Edit/stall/EditStall";
import MyFranchises from "./pages/CRUD/Edit/franchise/MyFranchises";
import EditFranchise from "./pages/CRUD/Edit/franchise/EditFranchise";
import MyBusinesses from "./pages/CRUD/Edit/business/MyBusinesses";
import EditBusiness from "./pages/CRUD/Edit/business/EditBusiness";
import ManageUsers from "./pages/Admin/ManageUsers";
import AdminUserPosts from "./pages/Admin/AdminUserPosts";
import AdminHome from "./pages/Admin/AdminHome";
import ForgotPassword from "./pages/Auth/Login/ForgotPassword";
import ResetPassword from "./pages/Auth/Login/ResetPassword";
import Contact from "./pages/Contact/Contact";
import AdminAdsApproval from "./pages/Admin/AdminAdsApproval";
import Ads from "./pages/CRUD/Add/Ads";
import AdsDetails from "./pages/CRUD/Details/AdsDetails";
import MyAds from "./pages/CRUD/Edit/Ads/MyAds";
import EditAds from "./pages/CRUD/Edit/Ads/EditAds";
import Adss from "./pages/List/Adss";
import NotFound from "./pages/NotFound/NotFound";
import SuccessPage from "./success/SuccessPage";

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate loading (or wait for API/auth check)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollTopButton />
      <Navbar />

      <Routes>
        {/* public + user routes (unchanged) */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <PersonalDetails />
            </ProtectedRoute>
          }
        />
        <Route path="/explore" element={<Explore />} />
        <Route
          path="/add"
          element={
            <ProtectedRoute>
              <AddYours />
            </ProtectedRoute>
          }
        />
        <Route path="/commercial-spaces" element={<CommercialSpaces />} />
        <Route path="/commercial-space/:slug" element={<CommercialSpaceDetails />} />
        <Route path="/stalls" element={<Stalls />} />
        <Route path="/franchises" element={<Franchises />} />
        <Route path="/businesses" element={<Businesses />} />
        <Route
          path="/add-commercial-space"
          element={
            <ProtectedRoute>
              <AddCommercialSpace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-stall"
          element={
            <ProtectedRoute>
              <AddStall />
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-franchise"
          element={
            <ProtectedRoute>
              <AddFranchise />
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-business"
          element={
            <ProtectedRoute>
              <AddBusiness />
            </ProtectedRoute>
          }
        />
        <Route path="/stall/:slug" element={<StallDetails />} />
        <Route path="/franchise/:slug" element={<FranchiseDetails />} />
        <Route path="/business/:slug" element={<BusinessDetails />} />
        <Route
          path="/my-commercial-spaces"
          element={
            <ProtectedRoute>
              <MyCommercialSpaces />
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-commercial-space/:id"
          element={
            <ProtectedRoute>
              <EditCommercialSpace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-stalls"
          element={
            <ProtectedRoute>
              <MyStalls />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-stall/:id"
          element={
            <ProtectedRoute>
              <EditStall />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-franchises"
          element={
            <ProtectedRoute>
              <MyFranchises />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-franchise/:id"
          element={
            <ProtectedRoute>
              <EditFranchise />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-businesses"
          element={
            <ProtectedRoute>
              <MyBusinesses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-business/:id"
          element={
            <ProtectedRoute>
              <EditBusiness />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            localStorage.getItem("token") ? <Contact /> : <Navigate to="/login" />
          }
        />
        <Route path="/ads" element={<Adss />} />
        <Route path="/ads/:slug" element={<AdsDetails />} />
        <Route
          path="/add-ads"
          element={
            <ProtectedRoute>
              <Ads />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-ads"
          element={
            <ProtectedRoute>
              <MyAds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-ads/:id"
          element={
            <ProtectedRoute>
              <EditAds />
            </ProtectedRoute>
          }
        />

        {/* admin layout + nested admin pages */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        >
          {/* default when you visit /admin */}
          <Route index element={<AdminHome />} />

          <Route
            path="commercial-approvals"
            element={<AdminCommercialApprovals />}
          />
          <Route
            path="stall-approvals"
            element={<AdminStallApprovals />}
          />
          <Route
            path="franchise-approvals"
            element={<AdminFranchiseApprovals />}
          />
          <Route
            path="business-approvals"
            element={<AdminBusinessApprovals />}
          />
          <Route
            path="manage-users"
            element={<ManageUsers />}
          />
          <Route
            path="user-posts/:id"
            element={<AdminUserPosts />}
          />
          <Route
            path="ads-approvals"
            element={<AdminAdsApproval />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
